<template>
  <MainViewFrame>
    <div class="detailSchool" ref="detailSchool">
      <div class="item" v-if="currentSchool">
        <div class="logo"><img :src="getImg(currentSchool.logo)" /></div>
        <div class="rightView">
          <span class="title">
            {{ currentSchool.name }}
            <img v-if="currentSchool.is_founder" class="icon" :src="images.update" @click="updateSchool()"/>
            <span v-if="currentSchool.is_member" class="inviteIcon" @click="inviteEvent()">
              <img :src="images.invite" />
              收徒
            </span>
            
          </span>
          <p class="content">{{ currentSchool.content }}</p>
          <p class="desc">
            <span class="position">师父: {{ currentSchool.owner.name }}</span>
            <span class="position" v-if="currentSchool.owner.job_title">级别: {{ currentSchool.owner.job_title }}</span>
            <span class="position">徒弟人数: {{ currentSchool.member_count }}</span>
          </p>
        </div>
      </div>

      <div class="tabs">
        <span
          :class="`tab ${tag === 'member' ? 'select' : ''}`"
          @click="setTag('member')"
          >我的徒弟</span
        >
        <span
          :class="`tab ${tag === 'product' ? 'select' : ''}`"
          @click="setTag('product')"
          >徒弟作业</span
        >
        <span
          v-if="currentSchool && currentSchool.is_member"
          :class="`tab ${tag === 'meeting' ? 'select' : ''}`"
          @click="setTag('meeting')"
          >学校会议室</span
        >
      </div>

      <SchoolMember v-if="tag === 'member'" />
      <SchoolProduct v-else-if="tag === 'product'" />
      <SchoolMeeting v-else-if="tag === 'meeting' && currentSchool && currentSchool.is_member " />
    </div>
    <!-- 修改公司 UI -->
    <SchoolCreate ref="createSchool" tag="shadow">
      <SchoolCreate :current-school="currentSchool"/>
    </SchoolCreate>
    <!-- 邀请好友 -->
    <SchoolPoster ref="schoolPoster"/>
  </MainViewFrame>
</template>

<script>
// @ is an alias to /src
import MainViewFrame from "../MainViewFrame.vue";
import SchoolProduct from "./SchoolProduct.vue";
import SchoolMember from "./SchoolMember.vue";
import SchoolCreate from './SchoolCreate'
import SchoolPoster from './SchoolPoster'
import SchoolMeeting from './SchoolMeeting'

import { Utils } from "@/utils";

import { types as LoginTypes } from "@/store/modules/login";
import { types as SchoolTypes } from "@/store/modules/school";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import { 
  IMG_TIP_ARROW_TOP, 
  IMG_COMPANY_UPDATE_ICON, 
  IMG_INVITE_ICON 
} from '@/assets';

export default {
  name: "SchoolDetail",
  components: {
    MainViewFrame,
    SchoolProduct,
    SchoolMember,
    SchoolCreate,
    SchoolPoster,
    SchoolMeeting
  },
  props: {},
  data() {
    return {
      tag: "member",
      school_id: 0,
      images:{
        tip_arrow: IMG_TIP_ARROW_TOP,
        update: IMG_COMPANY_UPDATE_ICON,
        invite: IMG_INVITE_ICON
      }
    };
  },
  watch: {},
  computed: {
    ...mapState({
      ownerInfo: state => state.login.userInfo,
      currentSchool: state => state.school.currentSchool
    })
  },
  methods: {
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
      fetchDetailSchool: SchoolTypes.FETCH_DETAIL_SCHOOL
    }),
    ...Utils,

    setTag(tag) {
      this.tag = tag;
    },
    updateSchool(){
      this.$refs.createSchool.showShadowView()
    },
    inviteEvent(){
      // 邀请好友
      this.$refs.schoolPoster.show(this.school_id, this.ownerInfo.user_id)
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    let school_id = this.$route.params.school_id;
    this.school_id = school_id;
    this.dependLoginStatus("no_toast").then(()=>{
      this.fetchOwnInfo()
    })
    
    this.fetchDetailSchool({ pk: this.school_id });
  }
};
</script>

<style lang="less" scoped>
// .mainViewFrame {
//   background-color: #6b45e1;
//   min-width: 1100px;
//   min-height: 900px;
// }
.detailSchool {
  width: 100%;
  background-color: #ffffff;
  border-radius: 5px;
  min-height: 500px;
  overflow: hidden;
  .item {
    display: flex;
    flex-direction: row;
    // align-items: center;
    padding: 15px;
    padding-bottom: 0;
    .logo {
      width: 100px;
      height: 100px;
      margin-right: 15px;
      border-radius: 8px;
      background-color: #F4F3F3;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      img{
        width: 100%;
        max-height: 100%;
      }
    }
    .rightView {
      flex: 1;
      // height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      .title {
        color: #333333;
        font-size: 15px;
        margin-bottom: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        .icon{
          margin-left: 10px;
          width: 15px;
          height: 15px;
          cursor: pointer;
        }
        .inviteIcon{
          color: #541DFF;
          font-size: 12px;
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;
          position: absolute;
          right: 0;
          img{
            width: 20px;
            height: 20px;
            margin-right: 5px;
          }
        }
      }
      .content {
        color: #666666;
        font-size: 13px;
        line-height: 23px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: 5px;
        // height: 50px;
      }
      .desc {
        display: flex;
        flex-direction: row;
        color: #999999;
        font-size: 13px;
        position: relative;
        .position {
          margin-right: 30px;
          color: #6b45e1;
          color: #333333;
        }
        .product {
          margin-right: 10px;
          color: #f56501;
          color: #333333;
        }
        .income {
          color: #6b45e1;
          position: absolute;
          right: 0px;
          cursor: pointer;
          font-weight: bold;
        }
      }
      
      .tipView {
        position: absolute;
        right: 0px;
        bottom: -120px;
        z-index: 666;
        .arrow {
          // width: 30px;
          height: 22px;
              margin-left: 88%;
        }
        .tip {
          background-color: #fff8e3;
          border: solid 5px #6b45e1;
          border-radius: 10px;
          font-size: 14px;
          color: #333333;
          padding: 10px 20px;
    line-height: 30px;
        height: 60px;
        }
      }
    }
  }
  .tabs {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-top: 18px;
    .tab {
      color: #666666;
      font-size: 15px;
      margin: 0 30px 0;
      padding-bottom: 3px;
      cursor: pointer;
      &.select {
        color: #ff7b00;
        border-bottom: solid 1.5px #f56501;
        font-weight: bold;
      }
    }
  }
}
</style>
